import axios from '../lib/axios';

export const getUsers = () =>
    axios.get('/api/manager/users').then(r => r.data);

export const createUser = (data) =>
    axios.post('/api/manager/users', data).then(r => r.data);

export const updateUser = ({ id, ...data }) =>
    axios.put(`/api/manager/users/${id}`, data).then(r => r.data);

export const deleteUser = (id) =>
    axios.delete(`/api/manager/users/${id}`).then(r => r.data);
